module.exports = __webpack_public_path__ + "static/media/04.f0d1f154.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/australia-two/04.jpg
// module id = 397
// module chunks = 0